import hotkeys from 'hotkeys-js';
import safeLocalStorage from '../helpers/safeLocalStorage';

const FIXED_NAVIGATION = {
  STORAGE_KEY: 'is_header_nav_fixed',
  YES_VALUE: 'yes',
  NO_VALUE: 'no',
  FIXED_CLASS_NAME: '-fixed',
};

function saveIsNavigationFixedToLocalStorage(isFixed) {
  safeLocalStorage.setItem(
    FIXED_NAVIGATION.STORAGE_KEY,
    isFixed ? FIXED_NAVIGATION.YES_VALUE : FIXED_NAVIGATION.NO_VALUE,
  );
}

function getIsNavigationFixedFromLocalStorage() {
  return safeLocalStorage.getItem(FIXED_NAVIGATION.STORAGE_KEY) === FIXED_NAVIGATION.YES_VALUE;
}

export function setupHotkeys() {
  const navigationRoot = document.getElementById('navigation');

  function setNavigationState(isFixed) {
    if (isFixed) {
      navigationRoot.classList.add(FIXED_NAVIGATION.FIXED_CLASS_NAME);
    } else {
      navigationRoot.classList.remove(FIXED_NAVIGATION.FIXED_CLASS_NAME);
    }
  }

  function isNavigationFixed() {
    return navigationRoot.classList.contains(FIXED_NAVIGATION.FIXED_CLASS_NAME);
  }

  const isNavigationInitiallyFixed = getIsNavigationFixedFromLocalStorage();
  if (isNavigationInitiallyFixed) {
    setNavigationState(true);
  }

  hotkeys('shift+f+h', () => {
    const isCurrentlyFixed = isNavigationFixed();

    // toggle navigation state
    const nextIsFixed = !isCurrentlyFixed;

    setNavigationState(nextIsFixed);
    saveIsNavigationFixedToLocalStorage(nextIsFixed);
  });
}
